import { render, staticRenderFns } from "./teaser-card.html?vue&type=template&id=32b3184d&scoped=true&"
import script from "./teaser-card.js?vue&type=script&lang=js&"
export * from "./teaser-card.js?vue&type=script&lang=js&"
import style0 from "./teaser-card.scss?vue&type=style&index=0&id=32b3184d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b3184d",
  null
  
)

export default component.exports